import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/PLANS';

export const {
    action: fetchPlansByChildIds,
    success: fetchPlansByChildIdsSuccess,
    failed: fetchPlansByChildIdsFailed,
} = createAction(`${domain}/FETCH_PLANS_BY_CHILD_IDS`, childIds => ({childIds}));
